export default "__VITE_ASSET__QpXQwFUb__"